import {InputTextLabelText } from "./style"
interface InputTextLabelProps {
    label: string;
    color?: string;
    marginbottom?: string;
}

export const InputTextLabel: React.FC<InputTextLabelProps> = ({ label, color, marginbottom }) => {
    return (
        <InputTextLabelText color={color} marginbottom={marginbottom}>
            {label}
        </InputTextLabelText>
    )
}